import { render } from "./WMTSLayer.vue?vue&type=template&id=0f913127"
import script from "./WMTSLayer.vue?vue&type=script&lang=js"
export * from "./WMTSLayer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__